import { Controller, FieldValues } from 'react-hook-form'
import { RhfProps } from './rhf.props'
import { RadioGroupField, RadioGroupFieldProps } from '../radio-group-field'

export type RadioGroupFieldRhfProps<T extends FieldValues> = RadioGroupFieldProps & RhfProps<T> & {}

export function RadioGroupFieldRhf<T extends FieldValues>({
  name,
  control,
  rules = {},
  defaultValue,
  ...rest
}: RadioGroupFieldRhfProps<T>) {
  if (rest.required) {
    rules.required = 'This field is required'
  }
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <RadioGroupField
          {...rest}
          name={name}
          value={value}
          onValueChange={onChange}
          error={!!error}
          helperText={error ? error.message : rest.helperText}
        />
      )}
    />
  )
}
